
import availableTypesList from 'components/Templates/availableTypesList';

export default async function injectComponentIntoCache(themeType) {


  const mapAll = await Promise.all(availableTypesList.map(async (type) => {
    try {
      if (!type) return;

      const awaitComponents = await import(`components/Templates/components/${type.toLowerCase()}/index.js`);
  
      let allComponents = awaitComponents.default;
  
      if (allComponents) {
        allComponents = await Promise.all(allComponents.map(async (thisElement) => {
          let themeComponentName = themeType+type;
          if (type === 'gallery' && themeComponentName.toLowerCase() === 'redgallery') {
            themeComponentName = 'redimage';
          }
          if (thisElement.toLowerCase() === themeComponentName.toLowerCase()){

            const awaitCompoent = await import(`components/Templates/components/${type.toLowerCase()}/${thisElement}/index.js`);
            
            if (awaitCompoent) window.componentsCache[thisElement] = awaitCompoent;
            const awaitStyle = await import(`components/Templates/components/${type.toLowerCase()}/${thisElement}/styling.js`);
            if (awaitStyle) window.stylesCache[thisElement] = awaitStyle;
            const awaitDefault = await import(`components/Templates/components/${type.toLowerCase()}/${thisElement}/defaultStyles.js`);
            if (awaitDefault) window.customStylesCache[thisElement] = awaitDefault;
          }
        }).filter((a) => a));
      }
    } catch(error) {
      console.log(error, type, themeType)
    }
  }));



}
